import { useEffect, useState } from 'react';

/** The value, but only after it stayed unchanged for `delay` ms (for search inputs). */
function useDebouncedValue<T>(value: T, delay: number): T {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delay);
		return () => clearTimeout(timer);
	}, [value, delay]);

	return debounced;
}

export default useDebouncedValue;
